import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { ViewModelForm } from "gw-portals-viewmodel-react";
import metadata from "./CoverageTable.metadata.json5";
import "./CoverageTable.messages";

const getCell = (items, index, property) => {
    return !_.isObject(items[property.id]) ? items[property.id] : null;
};

export function CoverageTable({ data }) {
    const overrides = {
        coverageTable: {
            data: data,
        },
        
    };

    const resolvers = {
        resolveCallbackMap: {
            getCellCoverage: getCell,
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={data}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

CoverageTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({})),
};

CoverageTable.defaultProps = {
    data: [],
};




export default CoverageTable;
